export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center text-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0c63716342b8e2585aa52b3dfdfd6a48.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Company name at top */}
      <div className="absolute top-24 md:top-28 left-0 w-full flex justify-center z-10">
        <span className="text-white/70 text-sm md:text-base font-light tracking-[0.25em] uppercase">
          IDEL SH.P.K.
        </span>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-5xl px-4 md:px-8 flex flex-col items-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          <span className="text-white/80 text-xs tracking-widest uppercase font-medium">iOS Development Studio</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 tracking-tight">
          Crafting Premium<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300">iOS Experiences</span>
        </h1>

        <p className="text-white/70 text-base md:text-xl max-w-2xl leading-relaxed font-light">
          We are a team of experts building modern, secure, and high-performance applications for the iOS platform — enhancing user experience across every device.
        </p>

        <div className="mt-12 flex items-center gap-3 text-white/40 text-sm cursor-pointer" onClick={() => handleScroll("#products")}>
          <span>Explore our products</span>
          <i className="ri-arrow-down-line animate-bounce text-lg"></i>
        </div>
      </div>
    </section>
  );
}
